import { RuleBase } from "csi/middleware/attributeRule/RuleStore";
import { FlexColumn, FlexRowCenter, Text } from "designSystem/index";
import { ComponentItem } from "designSystem/types/component-item-types";
import React from "react";
import CustomViewConditionOperator from "./CustomViewConditionOperator";

interface CustomViewFilterLeftColumnProps {
	count: number;
	index: number;
	isFlexRow?: boolean;
	onChange: (condition: ComponentItem<RuleBase>) => void;
	options: ComponentItem<RuleBase>[];
	value: ComponentItem<RuleBase>;
}

const CustomViewFilterLeftColumn: React.FC<CustomViewFilterLeftColumnProps> = ({
	count,
	index,
	isFlexRow,
	onChange,
	options,
	value,
}) => {
	const FlexComponent = isFlexRow ? FlexRowCenter : FlexColumn;

	return (
		<FlexComponent width={62}>
			{index === 0 ? (
				<Text res="Where" />
			) : (
				<CustomViewConditionOperator
					count={count}
					index={index}
					onChange={onChange}
					options={options}
					value={value}
				/>
			)}
		</FlexComponent>
	);
};

export default CustomViewFilterLeftColumn;
